import React,  { Component } from 'react';

import {Row, Col} from 'react-bootstrap';


class UploadDescription extends Component {

  render() {

    return (
      <div >
        <Row>
          <Col>
            Please use the upload form in the lower portion of this page to submit the requested documents. Prior to clicking "Upload", please make sure the documents being uploaded contain the following information:
          </Col>
        </Row>
         <Row>
          <Col>&nbsp;
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6}>
            <strong>Agent Information:</strong>
            <ul>
              <li>Insurance agent's name</li>
              <li>Insurance agent's address</li>
              <li>Insurance agent's telephone number</li>
            </ul>
            <strong>Property Information:</strong>
            <ul>
              <li>Property address or vehicle year, make, and model</li>
            </ul>
          </Col>
          <Col xs={12} className="d-md-none">
            &nbsp;
          </Col>
          <Col xs={12} md={6}>
            <strong>Insurance Information:</strong>
            <ul>
              <li>Insured's name and address</li>
              <li>Insurance company's name</li>
              <li>Policy number</li>
              <li>Effective date of insurance</li>
              <li>Coverage amount</li>
              <li>Deductibles</li>
              <li>Mortgagee, lienholder, or loss payee</li>
            </ul>
          </Col>
        </Row>
      </div>
    );
  }
}
export default UploadDescription;
